package songwritersnotebook.app.utils

import songwritersnotebook.app.data.ChordDefinition
import songwritersnotebook.app.data.Song
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonElement

@Serializable
data class HarmonyServerRequest(
    val prompt: String,
    val audioData: String? = null,
    val audioMimeType: String? = null,
    val songState: Song,
    val libraryChords: List<ChordDefinition>,
    val guitarTuning: List<String>?,
    val guitarCapo: Int?,
    val confirmationRequired: Boolean = true
)

@Serializable
data class HarmonyToolCall(
    val name: String,
    val args: JsonElement
)

@Serializable
data class HarmonyServerResponse(
    val status: String? = null,
    val message: String? = null,
    val textResponse: String? = null,
    val toolCalls: List<HarmonyToolCall> = emptyList(),
    val creditsUsed: Int = 0,
    val transcript: String? = null
)

class AiHarmonyService(private val client: HttpClient) {
    private val jsonParser = Json { ignoreUnknownKeys = true }

    suspend fun askHarmony(
        prompt: String,
        audioData: String?,
        audioMimeType: String?,
        songState: Song,
        libraryChords: List<ChordDefinition>,
        guitarTuning: List<String>?,
        guitarCapo: Int?,
        idToken: String,
        confirmationRequired: Boolean
    ): HarmonyServerResponse {
        val requestBody = HarmonyServerRequest(
            prompt = prompt,
            audioData = audioData,
            audioMimeType = audioMimeType,
            songState = songState,
            libraryChords = libraryChords,
            guitarTuning = guitarTuning,
            guitarCapo = guitarCapo,
            confirmationRequired = confirmationRequired
        )

        try {
            val appCheckToken = songwritersnotebook.app.getAppCheckToken()
            val responseText: String = client.post(API_URL) {
                headers {
                    append(HttpHeaders.Authorization, "Bearer $idToken")
                    if (appCheckToken != null) {
                        append("X-Firebase-AppCheck", appCheckToken)
                    }
                }
                contentType(ContentType.Application.Json)
                setBody(requestBody)
            }.body()

            return try {
                jsonParser.decodeFromString<HarmonyServerResponse>(responseText)
            } catch (e: Exception) {
                e.printStackTrace()
                HarmonyServerResponse(status = "error", message = "Failed to parse response: ${e.message}")
            }

        } catch (e: Exception) {
            e.printStackTrace()
            return HarmonyServerResponse(status = "error", message = e.message ?: "Network block error")
        }
    }

    companion object {
        private const val API_URL = "https://askharmony-7f6uyaw35q-uc.a.run.app"
    }
}
